import { Link } from "react-router-dom";
import { ArrowUpRight, Camera, ImageIcon, Palette } from "lucide-react";

const ROWS = [
  {
    icon: Camera,
    slug: "royal-essence",
    name: "Royal Essence",
    voice: "I want the complete Crowned experience, including photography.",
    price: "$249.99",
  },
  {
    icon: ImageIcon,
    slug: "sovereign",
    name: "Sovereign Canvas",
    voice: "I already have the photograph I want transformed.",
    price: "$149.99",
  },
  {
    icon: Palette,
    slug: "majestic-vibes",
    name: "Majestic Vibes",
    voice: "I have an idea, aesthetic or vision I want turned into artwork.",
    price: "$149.99",
  },
];

export default function ExperienceCompare() {
  return (
    <section data-testid="experience-compare" className="relative z-10 border-t border-white/5 py-24 md:py-32 bg-[#111111]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-6">
            <p className="overline">Compare Experiences</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.02]">
              Which Crowned experience<br />
              is <span className="italic text-[#D4AF37]">right for you?</span>
            </h2>
          </div>
          <p className="md:col-span-5 md:col-start-8 text-[#F7F1E7]/60 font-light leading-relaxed self-end">
            Three commissioned experiences — different starting points
            depending on what you bring us. Every one ends with artwork
            proofed with you before production.
          </p>
        </div>

        <div className="border border-white/10">
          {ROWS.map((r, i) => {
            const Icon = r.icon;
            return (
              <Link
                key={r.slug}
                to={`/collection/${r.slug}`}
                data-testid={`compare-${r.slug}`}
                className={`group flex flex-col md:flex-row md:items-center gap-6 p-6 md:p-8 hover:bg-[#824937]/15 transition-colors ${i > 0 ? "border-t border-white/10" : ""}`}
              >
                <div className="flex items-center gap-4 md:w-64 flex-shrink-0">
                  <div className="w-11 h-11 border border-[#D4AF37]/40 bg-[#824937]/20 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <p className="overline text-white/50">{r.price}</p>
                    <p className="font-serif-display text-xl md:text-2xl leading-tight mt-0.5">{r.name}</p>
                  </div>
                </div>
                <p className="flex-1 font-serif-display text-lg md:text-xl italic text-[#F7F1E7]/75 leading-snug">
                  &ldquo;{r.voice}&rdquo;
                </p>
                <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-white/70 group-hover:text-[#D4AF37] transition-colors flex-shrink-0">
                  Explore
                  <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
